import React from 'react'

import QrChannelPage from '../AddChannelPageWrapper/components/QrChannelPage'
import { channelTypes } from '../../utils/constants'

const AddWhatsappPage = () => {
   return <QrChannelPage channelType={channelTypes.WHATSAPP} />
}

export default AddWhatsappPage